export default {
  name: 'GuarantiesList',

  data() {
    return {
      /** Список гарантий */
      certificates: [],
      /** Процесс загрузки данных */
      loading: false,
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  methods: {
    /** Загрузить список гарантий */
    loadCertificates() {
      this.loading = true;
      this.$store.getters.axl
        .post('guaranties/api/guaranties/list', {
          profile_id: this.user.profile_id,
        })
        .then((response) => {
          this.certificates = response.data.guaranties;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** Цвет для соответствующего статуса */
    getStatusColor(certificate) {
      if (certificate.cert === 'wait') {
        return 'color-orange';
      } if (certificate.ending_status === 'pass') {
        return 'color-green';
      }
      return 'color-red';
    },
    /** Получить русскоязычное наименование статуса */
    getStatusName(certificate) {
      if (certificate.cert === 'wait') {
        return 'В ожидании';
      } if (certificate.ending_status === 'pass') {
        return 'Подтверждена';
      }
      return 'Отклонена';
    },
    /** Преобразовать дату */
    convertDate(date) {
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },
  mounted() {
    this.loadCertificates();
  },
};
